import React, {useEffect, useRef} from "react";
import {useSelector} from "react-redux";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";
import {object, string} from "yup";

import {Button} from "@pg-design/button-module";
import {Modal} from "@pg-design/modal-module";
import {FormProviderRHF, InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {Highlight, Text} from "@pg-design/text-module";
import {useFormRHF} from "@pg-mono/react-hook-forms-utils";

import type {IRPStore} from "../../app/rp_reducer";
import {closeFlowVariantB} from "../../auth/state/registration_flow_variantB_slice";
import {validationMessages} from "../../form/utils/validation_messages";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {useAppDispatch} from "../../store/hooks";
import {hitGtmUserPhoneNumber} from "../../tracking/google_tag_manager/gtm_user_phone_number";
import {useGetUserProfileQuery} from "../api/get_user_profile";
import {usePatchUserProfileMutation} from "../api/patch_user_profile";

interface IProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

interface IFormData {
    name: string;
    phone: {
        code: number;
        number: string;
    };
}

export const UserUpdatePhoneNumberModal = (props: IProps) => {
    const {isOpen, onSuccess} = props;
    const dispatch = useAppDispatch();
    const {data: userInfo} = useGetUserProfileQuery();

    const formDirtyRef = useRef<boolean>(false);
    const formTouchedRef = useRef<boolean>(false);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(validationMessages.required),
        ...(userInfo?.phone
            ? {}
            : {
                  phone: object().shape({
                      number: string()
                          .required("Podaj numer telefonu")
                          .matches(/^\d+$/, "Podaj poprawny numer telefonu")
                          .min(9, "Numer telefonu musi mieć 9 cyfr")
                          .max(9, "Numer telefonu musi mieć 9 cyfr")
                  })
              })
    });

    if (!userInfo) {
        return null;
    }

    useEffect(() => {
        if (isOpen) {
            hitGtmUserPhoneNumber("view");
        }
    }, [isOpen]);

    const [patchUserProfile] = usePatchUserProfileMutation();

    const countryCodes = useSelector((state: IRPStore) => state.variables.data?.country_codes ?? []);
    const userFirstName = userInfo.name?.split(" ")[0];
    const userPhone = userInfo.phone?.split(" ")[1];
    const form = useFormRHF<IFormData>({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        defaultValues: {
            name: userInfo.name ?? "",
            phone: {
                code: 48,
                number: userPhone ?? ""
            }
        }
    });

    useEffect(() => {
        if (form.formState.isDirty && !formDirtyRef.current) {
            formDirtyRef.current = true;

            hitGtmUserPhoneNumber("fill");
        }
    }, [form.formState.isDirty]);

    const onFormClick = () => {
        if (!formTouchedRef.current) {
            formTouchedRef.current = true;

            hitGtmUserPhoneNumber("click");
        }
    };

    const onCloseButton = () => {
        dispatch(closeFlowVariantB());
    };

    const onSubmit = async (values: IFormData) => {
        const response = await patchUserProfile({
            name: values.name,
            phone: `${values.phone?.code} ${values.phone?.number}`
        });

        hitGtmUserPhoneNumber("submit");

        if ("error" in response) {
            // TODO: Try to type this properly
            // @ts-ignore
            const {error}: {error: {data?: Record<string, string[]>}} = response;

            if (error.data) {
                for (const field of Object.keys(error.data)) {
                    const message = error.data[field];

                    form.setError(field as keyof IFormData, {
                        message: Array.isArray(message) ? message.join(", ") : message
                    });
                }
            } else {
                dispatch(addNotification({notification: defaultAPIErrorNotification}));
            }
        } else {
            onSuccess?.();
        }
    };

    return (
        <Modal isOpen={isOpen} onModalClose={onCloseButton} className={modalStyle}>
            <Modal.CloseButton placement="right" variant="rounded" className={css({m: 2})} />
            <Modal.Content>
                <Text variant="headline_3" align="left" mb={0.5}>
                    Witaj{" "}
                    {userInfo.name && (
                        <Highlight>
                            <span className={css({fontWeight: "700"})}>{userFirstName}</span>
                        </Highlight>
                    )}
                </Text>
                <Text variant="body_copy_2" mb={3}>
                    Uzupełnij swoje dane, aby odkryć wszystkie ceny.
                </Text>
                <FormProviderRHF {...form}>
                    <form className={formStyle} onSubmit={form.handleSubmit(onSubmit)}>
                        <div className={formStyle} onClick={onFormClick}>
                            <InputField name="name" placeholder="Imię i nazwisko" value={userInfo.name} disabled={!!userInfo.name} />
                            <PhoneFieldControlled name="phone" codes={countryCodes} placeholder="Telefon" maxMenuHeight={150} />
                        </div>
                        <Button variant="filled_primary" type="submit" fullWidth className={buttonStyle}>
                            POTWIERDŹ DANE
                        </Button>
                    </form>
                </FormProviderRHF>
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css({
    sm: {
        p: 2,
        borderRadius: 2,
        width: "544px"
    }
});

const formStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const buttonStyle = css({
    mt: 2
});
import React, {useEffect, useRef} from "react";
import {useSelector} from "react-redux";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";
import {object, string} from "yup";

import {Button} from "@pg-design/button-module";
import {Modal} from "@pg-design/modal-module";
import {FormProviderRHF, InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {Highlight, Text} from "@pg-design/text-module";
import {useFormRHF} from "@pg-mono/react-hook-forms-utils";

import type {IRPStore} from "../../app/rp_reducer";
import {closeFlowVariantB} from "../../auth/state/registration_flow_variantB_slice";
import {validationMessages} from "../../form/utils/validation_messages";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {useAppDispatch} from "../../store/hooks";
import {hitGtmUserPhoneNumber} from "../../tracking/google_tag_manager/gtm_user_phone_number";
import {useGetUserProfileQuery} from "../api/get_user_profile";
import {usePatchUserProfileMutation} from "../api/patch_user_profile";

interface IProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

interface IFormData {
    name: string;
    phone: {
        code: number;
        number: string;
    };
}

export const UserUpdatePhoneNumberModal = (props: IProps) => {
    const {isOpen, onSuccess} = props;
    const dispatch = useAppDispatch();
    const {data: userInfo} = useGetUserProfileQuery();

    const formDirtyRef = useRef<boolean>(false);
    const formTouchedRef = useRef<boolean>(false);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(validationMessages.required),
        ...(userInfo?.phone
            ? {}
            : {
                  phone: object().shape({
                      number: string()
                          .required("Podaj numer telefonu")
                          .matches(/^\d+$/, "Podaj poprawny numer telefonu")
                          .min(9, "Numer telefonu musi mieć 9 cyfr")
                          .max(9, "Numer telefonu musi mieć 9 cyfr")
                  })
              })
    });

    if (!userInfo) {
        return null;
    }

    useEffect(() => {
        if (isOpen) {
            hitGtmUserPhoneNumber("view");
        }
    }, [isOpen]);

    const [patchUserProfile] = usePatchUserProfileMutation();

    const countryCodes = useSelector((state: IRPStore) => state.variables.data?.country_codes ?? []);
    const userFirstName = userInfo.name?.split(" ")[0];
    const userPhone = userInfo.phone?.split(" ")[1];
    const form = useFormRHF<IFormData>({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        defaultValues: {
            name: userInfo.name ?? "",
            phone: {
                code: 48,
                number: userPhone ?? ""
            }
        }
    });

    useEffect(() => {
        if (form.formState.isDirty && !formDirtyRef.current) {
            formDirtyRef.current = true;

            hitGtmUserPhoneNumber("fill");
        }
    }, [form.formState.isDirty]);

    const onFormClick = () => {
        if (!formTouchedRef.current) {
            formTouchedRef.current = true;

            hitGtmUserPhoneNumber("click");
        }
    };

    const onCloseButton = () => {
        dispatch(closeFlowVariantB());
    };

    const onSubmit = async (values: IFormData) => {
        const response = await patchUserProfile({
            name: values.name,
            phone: `${values.phone?.code} ${values.phone?.number}`
        });

        hitGtmUserPhoneNumber("submit");

        if ("error" in response) {
            // TODO: Try to type this properly
            // @ts-ignore
            const {error}: {error: {data?: Record<string, string[]>}} = response;

            if (error.data) {
                for (const field of Object.keys(error.data)) {
                    const message = error.data[field];

                    form.setError(field as keyof IFormData, {
                        message: Array.isArray(message) ? message.join(", ") : message
                    });
                }
            } else {
                dispatch(addNotification({notification: defaultAPIErrorNotification}));
            }
        } else {
            onSuccess?.();
        }
    };

    return (
        <Modal isOpen={isOpen} onModalClose={onCloseButton} className={modalStyle}>
            <Modal.CloseButton placement="right" variant="rounded" className={css({m: 2})} />
            <Modal.Content>
                <Text variant="headline_3" align="left" mb={0.5}>
                    Witaj{" "}
                    {userInfo.name && (
                        <Highlight>
                            <span className={css({fontWeight: "700"})}>{userFirstName}</span>
                        </Highlight>
                    )}
                </Text>
                <Text variant="body_copy_2" mb={3}>
                    Uzupełnij swoje dane, aby odkryć wszystkie ceny.
                </Text>
                <FormProviderRHF {...form}>
                    <form className={formStyle} onSubmit={form.handleSubmit(onSubmit)}>
                        <div className={formStyle} onClick={onFormClick}>
                            <InputField name="name" placeholder="Imię i nazwisko" value={userInfo.name} disabled={!!userInfo.name} />
                            <PhoneFieldControlled name="phone" codes={countryCodes} placeholder="Telefon" maxMenuHeight={150} />
                        </div>
                        <Button variant="filled_primary" type="submit" fullWidth className={buttonStyle}>
                            POTWIERDŹ DANE
                        </Button>
                    </form>
                </FormProviderRHF>
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css({
    sm: {
        p: 2,
        borderRadius: 2,
        width: "544px"
    }
});

const formStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const buttonStyle = css({
    mt: 2
});
